import AddEditGoogleSource from "components/Leads/AddEditGoogleSource";

import CreateDestinationModal from "../CreateDestinationModal";
import CreateSourceModal from "../CreateSourceModal";
import CreateMetaCustomAudience from "../Modals/CreateMetaCustomAudience";

export enum ModalName {
    CREATE_SOURCE = "CREATE_SOURCE",
    CREATE_DESTINATION = "CREATE_DESTINATION",
    CREATE_META_CUSTOM_AUDIENCE = "CREATE_META_CUSTOM_AUDIENCE",
    ADD_EDIT_LEAD_GOOGLE = "ADD_EDIT_LEAD_GOOGLE",
}

const ModalMapping = {
    [ModalName.CREATE_DESTINATION]: CreateDestinationModal,
    [ModalName.CREATE_SOURCE]: CreateSourceModal,
    [ModalName.CREATE_META_CUSTOM_AUDIENCE]: CreateMetaCustomAudience,
    [ModalName.ADD_EDIT_LEAD_GOOGLE]: AddEditGoogleSource,
};

const ModalRoot = ({ modalName, data, isOpen, dispatchHideModal }) => {
    const ModalComponent = modalName ? ModalMapping[modalName] : null;
    return (
        ModalComponent &&
        isOpen && <ModalComponent data={data} closeModal={dispatchHideModal} />
    );
};

export default ModalRoot;
